import Hero from "../components/Hero";
import Programs from "../components/Programs";
import Impact from "../components/Impact";
import Mission from "../components/Mission";
import Donate from "../components/Donate";
import Media from "../components/Media";

export default function Home() {
  return (
    <>
      <Hero />
      <Programs />
      <Impact />
      <Mission />
      <Donate />
      <Media />
    </>
  );
}
